/** @var { PaymentState } */
const STATE = {
    data: null,
    // baseURL: 'http://localhost:8000/api/',
    paymentStatus: null,
};

export default STATE;
